module.exports = new __parcel__URL__("whale03.5e77c711.png").toString();